import React from 'react';
import Header from './components/header/Header';
import { Route, Routes, BrowserRouter as Router } from 'react-router-dom';
import Home from '@pages/Home';
import "bootstrap-icons/font/bootstrap-icons.css";
import Footer from '@components/footer/Footer';

function App() {
  return (
    <Router>
      <div className="App">
        <Home />
      </div>
    </Router>
  );
}

export default App;
